<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>{{ "CREDITS.PAYMENT.TITLE" | translate }}</mat-card-title>
  </mat-card-header>
  <mat-card-content class="payment-content">
    <form
      class="payment-form"
      [formGroup]="form"
    >
      <payee-form-field class="amount-form">
        <input
          payee-input
          formControlName="amount"
        />
        <span payee-label>
          {{ "CREDITS.PAYMENT.CUSTOM_AMOUNT" | translate }}
        </span>
      </payee-form-field>
      <payee-dropdown
        width="shorter"
        formControlName="currency_iso"
        [options]="currencyOptions"
      ></payee-dropdown>
    </form>

    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          {{ "CREDITS.PAYMENT.METHODS.TRANSFER.TITLE" | translate }}
        </mat-card-title>
        <mat-card-subtitle>
          {{ "CREDITS.PAYMENT.METHODS.TRANSFER.DESCRIPTION" | translate }}
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-actions>
        <button
          payee-button
          width="max"
          height="tall"
          color="alert-green"
          [disabled]="loading"
          (click)="onSelectTransferPayment()"
        >
          {{ "CREDITS.PAYMENT.METHODS.TRANSFER.BUTTON" | translate }}
        </button>
      </mat-card-actions>
    </mat-card>

    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          {{ "CREDITS.PAYMENT.METHODS.CARD.TITLE" | translate }}
        </mat-card-title>
        <mat-card-subtitle>
          {{ "CREDITS.PAYMENT.METHODS.CARD.DESCRIPTION" | translate }}
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-actions>
        <button
          payee-button
          width="max"
          height="tall"
          [disabled]="!allowCard || loading"
          (click)="onSelectCardPayment()"
        >
          {{ "CREDITS.PAYMENT.METHODS.CARD.BUTTON" | translate }}
        </button>
      </mat-card-actions>
    </mat-card>
  </mat-card-content>
</mat-card>
